import { render } from "./PosTicket.vue?vue&type=template&id=03e3071f&scoped=true"
import script from "./PosTicket.vue?vue&type=script&lang=js"
export * from "./PosTicket.vue?vue&type=script&lang=js"

import "./PosTicket.vue?vue&type=style&index=0&id=03e3071f&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/MISTOCK/mi-stock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e3071f"]])

export default __exports__